import { render, staticRenderFns } from "./BrandEquipmentList.vue?vue&type=template&id=10f0160f"
import script from "./BrandEquipmentList.vue?vue&type=script&lang=js"
export * from "./BrandEquipmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports